<mat-sidenav-container class="client-container">
  <mat-sidenav
    style="width: 80%"
    class="main row client_details"
    #sidenav
    mode="over"
    position="end"
    [opened]="clientDetailsSheetActive"
    disableClose
  >
    <div class="sliding-sheet-header">
      <h4>Client Details</h4>
      <button type="button" (click)="closeClientDetailSheet()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="client-header">
      <div class="clnt_cnt_dtls container pt-0">
        <div class="row mt-2">
          <div class="client-name">
            <h3 class="mb-1">{{ activeClient.firstName }} {{ activeClient.lastName }}</h3>
            <span class="account-status-badge verified" *ngIf="activeClient.emailVerificationDate"> VERIFIED </span>
            <span class="account-status-badge unverified" *ngIf="!activeClient.emailVerificationDate">
              UNVERIFIED
            </span>
            <span
              *ngIf="activeClient.tag && activeClient.tag.length"
              class="lead-status-badge"
              [ngClass]="activeClient.tag[2] || activeClient.tag[1] || activeClient.tag[0]"
            >
              {{ activeClient.tag[2] || activeClient.tag[1] || activeClient.tag[0] | uppercase }}
            </span>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-4 col-sm-6 col-12 mb-2">
            <p class="client-dtls mb-2">
              <i _ngcontent-rfs-c349="" class="material-icons">email </i>{{ activeClient.email }}
            </p>
            <p class="client-dtls mb-2" *ngIf="activeClient.phone">
              <i _ngcontent-rfs-c349="" class="material-icons">phone </i>{{ activeClient.phone }}
            </p>
            <p class="client-dtls text-level-2 logged_in mb-2">
              <i _ngcontent-rfs-c349="" class="material-icons">history </i>Last Logged In :
              {{ activeClient.lastLogInDate ? (activeClient.lastLogInDate | simpleDate) : 'N/A ' }}
            </p>
          </div>
          <div class="col-md-4 col-sm-6 col-12">
            <p class="mb-2"><b>Connected On :</b> {{ activeClient.createdDate | simpleDate }}</p>
            <p class="mb-2"><b>Connection Status :</b> {{ activeClient.connectionStatus | titlecase }}</p>
            <p *ngIf="!isValueTest" class="mb-1">
              <b>Lead Score :</b> {{ activeClient.totalActivityScore | number: '1.0-0' }}
            </p>
          </div>
          <div class="col-md-4 col-sm-6 col-12" *ngIf="!isValueTest">
            <p class="mb-2">
              <b>Interested Areas : </b>
              <span *ngIf="activeClient.interestedAreas && activeClient.interestedAreas.length">
                <ng-container
                  *ngFor="let area of activeClient.interestedAreas | slice: 0:activeClient.interestedAreas.length - 1"
                >
                  <span *ngIf="$any(area).locality && $any(area).state"
                    >{{ $any(area).locality }} , {{ $any(area).state }}</span
                  >
                  |
                </ng-container>
                <ng-container *ngIf="activeClient.interestedAreas[activeClient.interestedAreas.length - 1].locality">
                  {{ activeClient.interestedAreas[activeClient.interestedAreas.length - 1].locality }},
                  {{ activeClient.interestedAreas[activeClient.interestedAreas.length - 1].state }}
                </ng-container>
                <ng-container *ngIf="!activeClient.interestedAreas[activeClient.interestedAreas.length - 1].locality">
                  <b>--</b>
                </ng-container>
              </span>
            </p>
            <p class="mb-2" *ngIf="(appState.companyInfo$ | async).appConfig?.dealAnalysis?.isEnabled">
              <b>Deal Saved :</b> {{ totalSavedDeals }}
            </p>
          </div>
        </div>
        <form [formGroup]="leadStatusForm" *ngIf="!isValueTest">
          <div class="row">
            <div class="col-md-4 col-sm-4 col-12">
              <p class="mt-3 mb-0">
                <b>Lead Type :</b
                ><mat-radio-group formControlName="leadType">
                  <mat-radio-button value="buyer" style="margin-left: 16px"> &nbsp;Buyer </mat-radio-button>
                  <mat-radio-button value="seller" style="margin-left: 16px">&nbsp; Seller </mat-radio-button>
                  <mat-radio-button value="buyer_seller" style="margin-left: 16px"
                    >&nbsp; Buyer/Seller
                  </mat-radio-button>
                </mat-radio-group>
              </p>
            </div>
            <div class="col-md-4 col-sm-4 col-12 lead-status">
              <mat-form-field appearance="fill" class="w-75">
                <mat-label>Lead Status </mat-label>
                <mat-select formControlName="leadStatus">
                  <mat-option *ngFor="let leadStatus of leadStatusList" [value]="leadStatus?.index">
                    {{ leadStatus?.displayText }}
                  </mat-option>
                </mat-select>
                <mat-spinner *ngIf="isSubmitInProgress" [diameter]="20" strokeWidth="3"></mat-spinner>
              </mat-form-field>
            </div>
            <div
              class="col-md-4 col-sm-4 col-12"
              *ngIf="
                (activeClient.emailVerificationDate != null && activeClient.status == 'new') ||
                (activeClient.emailVerificationDate == null && activeClient.status == 'new') ||
                (activeClient.emailVerificationDate == null && activeClient.status == 'active')
              "
            >
              <div class="invitation-btn">
                <button
                  mat-stroked-button
                  color="primary"
                  class="mt-3 resend-btn"
                  (click)="resendActivationMail()"
                  [pmx-progress-button]="isResendActivationInProgress"
                >
                  <mat-icon inline>send</mat-icon>
                  Resend Invitation
                </button>
                <p class="text-level-3 mb-0 mt-1">
                  Last sent on <b>{{ activeClient.lastSignUpReminderDate | simpleDate }}</b>
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="clnt_cnt_dtls container">
      <div class="row">
        <div class="col-lg-12 mt-2">
          <mat-accordion multi="true" class="subSection">
            <ng-container>
              <mat-expansion-panel class="mb-3" [expanded]="expandListingsTab">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h5 class="my-3 headWrap">Listings</h5>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="flex_center w-100" *ngIf="loadListings">
                  <div class="notFound text-center noData">
                    <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
                    <h4>Please wait while we load</h4>
                  </div>
                </div>

                <div *ngIf="!loadListings">
                  <div class="row w-100 prop-list" *ngIf="propertyList.length; else noListings">
                    <div class="col-md-12 col-sm-12 col-xs-12 mb-3" *ngFor="let property of propertyList">
                      <app-listings-card class="prop-card" [property]="property"> </app-listings-card>
                    </div>
                  </div>
                </div>

                <ng-template #noListings>
                  <div class="flex_center w-100">
                    <div class="notFound text-center noData">
                      <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                      <h4>No listings found</h4>
                    </div>
                  </div>
                </ng-template>

                <mat-paginator
                  #myListingsPaginator
                  [length]="propertyTotalCount"
                  [pageSizeOptions]="[2, 4]"
                  (page)="pageChangeOnlistings($event)"
                >
                </mat-paginator>
              </mat-expansion-panel>
            </ng-container>

            <mat-expansion-panel class="mb-3" [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h5 class="my-3 headWrap note-head">Notes</h5>
                  <button
                    mat-stroked-button
                    type="button"
                    color="primary"
                    class="m-3"
                    (click)="$event.stopPropagation(); addMessage('add', '')"
                  >
                    Add note
                  </button>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="table-responsive table_wrap">
                <table
                  mat-table
                  [dataSource]="noteDataSource"
                  *ngIf="noteDataSource && noteDataSource.data && noteDataSource.data.length; else noNotes"
                  class="mat-elevation-z2 w-100"
                >
                  <ng-container matColumnDef="message">
                    <th mat-header-cell *matHeaderCellDef>Message</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.note | slice: 0:80 }}<span *ngIf="element.note.length > 80">..</span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="author">
                    <th mat-header-cell *matHeaderCellDef>Author</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.isOwner == true ? 'Me' : element.owner.firstName + ' ' + element.owner.lastName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>Date</th>
                    <td mat-cell *matCellDef="let element">{{ element.updatedDate | simpleDate }} {{ element.id }}</td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let element">
                      <button _ngcontent-eby-c333="" class="delete mat-icon-button">
                        <mat-icon
                          *ngIf="element.isOwner == true"
                          _ngcontent-eby-c333=""
                          role="img"
                          class="mat-icon notranslate material-icons mat-icon-no-color"
                          aria-hidden="true"
                          data-mat-icon-type="font"
                          (click)="$event.stopPropagation(); deleteNotes(element._id)"
                          >delete</mat-icon
                        >
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="notesColumnList"></tr>
                  <tr mat-row *matRowDef="let row; columns: notesColumnList" (click)="addMessage('update', row)"></tr>
                </table>
              </div>
              <ng-template #noNotes>
                <div class="flex_center w-100">
                  <div class="notFound text-center noData">
                    <div>
                      <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                      <h4>No notes found</h4>
                    </div>
                  </div>
                </div>
              </ng-template>
              <mat-paginator #paginator1 [pageSizeOptions]="[5, 10]" showFirstLastButtons> </mat-paginator>
            </mat-expansion-panel>

            <mat-expansion-panel class="mb-3" [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h5 class="my-3 headWrap">Connections</h5>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="ml-4 mb-3">
                <div class="row">
                  <div class="col-md-6 col-sm-6 col-12">
                    <h6 class="mb-3">Agent Details</h6>
                    <h4 class="mb-1">{{ connectionAgentInfo?.firstName }} {{ connectionAgentInfo?.lastName }}</h4>
                    <p class="mb-0">{{ connectionAgentInfo?.email }}</p>
                    <p class="mb-0">{{ connectionAgentInfo?.phone }}</p>
                    <br />
                    <button
                      *ngIf="authorizeService.canView('reassignConnection') && isReassignAgent"
                      mat-stroked-button
                      [disabled]="isDisableResetBtn"
                      (click)="reassignAgent()"
                    >
                      Reassign
                    </button>
                    <div *ngIf="isAgentList" class="row w-100">
                      <div class="col-md-8 col-sm-8 col-8">
                        <app-select-search-dropdown
                          class="agents"
                          [required]="true"
                          label="Agents"
                          [multiple]="false"
                          [options]="multiSelectOptions"
                          [canSelectAll]="false"
                          (selectedEvent)="updateSelectedOptions($event, 'agent')"
                          [lazyLoadComplete]="!hasMoreClientUsers"
                          (searchEvent)="searchClientUser($event)"
                          (scrollEndEvent)="fetchNextClientUserList()"
                          [isHideSearch]="'hide'"
                        >
                        </app-select-search-dropdown>
                      </div>
                      <div class="col-md-4 col-sm-4 col-4">
                        <button
                          mat-icon-button
                          aria-label="Reassign Agent"
                          matTooltip="Reassign Agent"
                          (click)="updateAgentDetails()"
                        >
                          <mat-icon class="text-success">done</mat-icon>
                        </button>

                        <button mat-icon-button aria-label="Cancel" matTooltip="Cancel" (click)="cancelAgent()">
                          <mat-icon class="text-danger">close</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-md-6 col-sm-6 col-12"
                    *ngIf="
                      (companyName === 'homehunt' &&
                        connectionLoanOfficerInfo?._id !== this.appState.companyInfoValue.defaultLoanOfficer) ||
                        (companyName !== 'homehunt' &&
                          (connectionLoanOfficerInfo?._id !== this.appState.companyInfoValue.defaultLoanOfficer ||
                            connectionLoanOfficerInfo?._id === this.appState.companyInfoValue.defaultLoanOfficer));
                      else loanOfficer
                    "
                  >
                    <h6 class="mb-3">Loan Officer Details</h6>
                    <h4 class="mb-1">
                      {{ connectionLoanOfficerInfo?.firstName }} {{ connectionLoanOfficerInfo?.lastName }}
                    </h4>
                    <p class="mb-0">{{ connectionLoanOfficerInfo?.email }}</p>
                    <p class="mb-0">{{ connectionLoanOfficerInfo?.phone }}</p>
                    <br />
                    <button
                      *ngIf="authorizeService.canView('reassignConnection') && isReassignLoanOfficer"
                      mat-stroked-button
                      (click)="reassignLoanOfficer()"
                    >
                      Reassign
                    </button>

                    <div *ngIf="isLoanOfficerList" class="row w-100">
                      <div class="col-md-8 col-sm-8 col-8">
                        <app-select-search-dropdown
                          class="clients"
                          label="Select Loan Officer"
                          [options]="multiSelectOptionsForLoanOfficer"
                          [required]="true"
                          [lazyLoadComplete]="!hasMoreLoanOfficers"
                          (selectedEvent)="updateSelectedOptions($event, 'loanOfficer')"
                          (scrollEndEvent)="fetchNextLoanOfficerUserList()"
                          (searchEvent)="searchLoanOfficerUser($event)"
                        ></app-select-search-dropdown>
                      </div>
                      <div class="col-md-4 col-sm-4 col-4">
                        <button
                          mat-icon-button
                          aria-label="Reassign Agent"
                          matTooltip="Reassign Agent"
                          (click)="updateLoanOfficerDetails()"
                        >
                          <mat-icon class="text-success">done</mat-icon>
                        </button>

                        <button mat-icon-button aria-label="Cancel" matTooltip="Cancel" (click)="cancelLoanOfficer()">
                          <mat-icon class="text-danger">close</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>

                  <ng-template #loanOfficer>
                    <div class="col-md-6 col-sm-6 col-12">
                      <h6 class="mb-3">Loan Officer Details</h6>
                      <br />
                      <button
                        *ngIf="authorizeService.canView('reassignConnection') && isReassignLoanOfficer"
                        mat-stroked-button
                        (click)="reassignLoanOfficer()"
                      >
                        Reassign
                      </button>

                      <div *ngIf="isLoanOfficerList" class="row w-100">
                        <div class="col-md-8 col-sm-8 col-8">
                          <app-select-search-dropdown
                            class="clients"
                            label="Select Loan Officer"
                            [options]="multiSelectOptionsForLoanOfficer"
                            [required]="true"
                            [lazyLoadComplete]="!hasMoreLoanOfficers"
                            (selectedEvent)="updateSelectedOptions($event, 'loanOfficer')"
                            (scrollEndEvent)="fetchNextLoanOfficerUserList()"
                            (searchEvent)="searchLoanOfficerUser($event)"
                          ></app-select-search-dropdown>
                        </div>
                        <div class="col-md-4 col-sm-4 col-4">
                          <button
                            mat-icon-button
                            aria-label="Reassign Agent"
                            matTooltip="Reassign Agent"
                            (click)="updateLoanOfficerDetails()"
                          >
                            <mat-icon class="text-success">done</mat-icon>
                          </button>

                          <button mat-icon-button aria-label="Cancel" matTooltip="Cancel" (click)="cancelLoanOfficer()">
                            <mat-icon class="text-danger">close</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="mb-3" [expanded]="false" *ngIf="!isValueTest">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h5 class="my-3 headWrap">Responses & Interests</h5>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div
                class="table-responsive table_wrap"
                *ngIf="qaDataSource && qaDataSource.data && qaDataSource.data.length; else noQASection"
              >
                <table mat-table [dataSource]="qaDataSource" class="mat-elevation-z2 w-100">
                  <ng-container matColumnDef="slNo">
                    <th mat-header-cell *matHeaderCellDef>No.</th>
                    <td mat-cell *matCellDef="let element">
                      {{ qaDataSource.data.indexOf(element) + 1 }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="question">
                    <th mat-header-cell *matHeaderCellDef>Queries</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.question }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="response">
                    <th mat-header-cell *matHeaderCellDef>Response</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.response }}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="qaColumnList"></tr>
                  <tr mat-row *matRowDef="let row; columns: qaColumnList"></tr>
                </table>
              </div>
              <ng-template #noQASection>
                <div class="flex_center w-100">
                  <div class="notFound text-center noData">
                    <div>
                      <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                      <h4>No responses found</h4>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel class="mb-3" [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h5 class="my-3 headWrap note-head">Sent Mails</h5>
                  <button
                    mat-stroked-button
                    type="button"
                    color="primary"
                    class="m-3"
                    (click)="$event.stopPropagation(); openCreateMailSheet()"
                  >
                    Compose Mail
                  </button>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div>
                <div class="flex_center w-100" *ngIf="isSentMailDataLoading">
                  <div class="notFound text-center noData">
                    <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
                    <h4>Please wait while we load</h4>
                  </div>
                </div>
                <div class="table-responsive table_wrap" *ngIf="!isSentMailDataLoading">
                  <table mat-table [dataSource]="sentMailDataSource" class="mat-elevation-z2 w-100">
                    <ng-container matColumnDef="authorName">
                      <th mat-header-cell *matHeaderCellDef>Author Name</th>
                      <td mat-cell *matCellDef="let element">{{ element.authorName }}</td>
                    </ng-container>
                    <ng-container matColumnDef="subject">
                      <th mat-header-cell *matHeaderCellDef>Subject</th>
                      <td mat-cell *matCellDef="let element">{{ element.subject }}</td>
                    </ng-container>
                    <ng-container matColumnDef="sentDate">
                      <th mat-header-cell *matHeaderCellDef>Sent Date</th>
                      <td mat-cell [propertyAddress]="element.details" *matCellDef="let element">
                        {{ element.createdDate | simpleDate }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="attachments">
                      <th mat-header-cell *matHeaderCellDef>Attachments</th>
                      <td mat-cell *matCellDef="let element">{{ element.file ? element.file.length : '' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="sentStatus">
                      <th mat-header-cell *matHeaderCellDef>Sent Status</th>
                      <td mat-cell *matCellDef="let element">{{ element.sendStatus }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="sentMailColumnList; sticky: true"></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: sentMailColumnList"
                      (click)="openSentMailDataSheet(row)"
                    ></tr>
                  </table>
                </div>
                <div class="flex_center w-100" *ngIf="!sentMailCount && !isSentMailDataLoading">
                  <div class="notFound text-center noData">
                    <div>
                      <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                      <h4>No sent mails found</h4>
                    </div>
                  </div>
                </div>
                <mat-paginator
                  [length]="sentMailCount"
                  #sentMailDataPaginator
                  [pageSizeOptions]="[5, 10]"
                  showFirstLastButtons
                >
                </mat-paginator>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="mb-3" [expanded]="false" *ngIf="appState.companyInfo$ | async as companyInfo">
              <mat-expansion-panel-header *ngIf="companyInfo?.appConfig?.dealAnalysis?.isEnabled">
                <mat-panel-title>
                  <h5 class="my-3 headWrap">Saved Deals</h5>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div *ngIf="companyInfo.appConfig.dealAnalysis.isEnabled">
                <div class="flex_center w-100" *ngIf="isSavedDealLoading">
                  <div class="notFound text-center noData">
                    <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
                    <h4>Please wait while we load</h4>
                  </div>
                </div>
                <div class="table-responsive table_wrap" *ngIf="!isSavedDealLoading">
                  <table mat-table [dataSource]="savedDealDataSource" class="mat-elevation-z2 w-100">
                    <ng-container matColumnDef="address">
                      <th mat-header-cell *matHeaderCellDef>Address</th>
                      <td mat-cell [propertyAddress]="element.address" *matCellDef="let element">
                        {{ element.address }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="count">
                      <th mat-header-cell *matHeaderCellDef>No. of Analysis</th>
                      <td mat-cell *matCellDef="let element">{{ element.count }}</td>
                    </ng-container>
                    <ng-container matColumnDef="lastUpdated">
                      <th mat-header-cell *matHeaderCellDef>Last Analyzed</th>
                      <td mat-cell *matCellDef="let element">{{ element.lastSaveDate | simpleDate }}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="savedDealsColumnList; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: savedDealsColumnList"></tr>
                  </table>
                </div>
                <div class="flex_center w-100" *ngIf="!isSavedDealLoading && !savedDealCount">
                  <div class="notFound text-center noData">
                    <div>
                      <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                      <h4>No saved rental analysis found</h4>
                    </div>
                  </div>
                </div>
                <mat-paginator
                  [length]="savedDealCount"
                  [pageSizeOptions]="[5, 10]"
                  (page)="pageChangeOnSavedDeals($event)"
                  showFirstLastButtons
                >
                </mat-paginator>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="mb-3" [expanded]="false" *ngIf="!isValueTest">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h5 class="my-3 headWrap note-head">Saved Searches</h5>
                  <button
                    mat-stroked-button
                    type="button"
                    color="primary"
                    class="m-3"
                    (click)="$event.stopPropagation(); openAddSavedSearchSheet()"
                  >
                    Add Search
                  </button>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div>
                <div class="flex_center w-100" *ngIf="isSavedSearchLoading">
                  <div class="notFound text-center noData">
                    <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
                    <h4>Please wait while we load</h4>
                  </div>
                </div>
                <div class="container px-3">
                  <div class="row">
                    <app-saved-search-card
                      [item]="item"
                      [canDelete]="false"
                      [editNeeded]="true"
                      (loadSearch)="loadSearch(item)"
                      (editSearch)="editSavedSearch(item)"
                      (deleteSavedDataForClients)="deleteSavedSearchForClients(item)"
                      class="col-md-4"
                      *ngFor="let item of savedSearchList$ | async"
                    ></app-saved-search-card>
                  </div>
                </div>
                <div class="flex_center w-100" *ngIf="!isSavedSearchLoading && !(savedSearchList$ | async)?.length">
                  <div class="notFound text-center noData">
                    <div>
                      <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                      <h4>No saved search found</h4>
                    </div>
                  </div>
                </div>
                <mat-paginator #savedSearchPaginator [pageSizeOptions]="[5, 10]"> </mat-paginator>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mb-3" [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h5 class="my-3 headWrap">My Home Properties</h5>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div>
                <div class="flex_center w-100">
                  <div class="notFound text-center noData" *ngIf="myPropertyLoading">
                    <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
                    <h4>Please wait while we load</h4>
                  </div>
                </div>
                <div
                  class="table-responsive table_wrap"
                  *ngIf="myHomePropertySource && myHomePropertySource.data && myHomePropertySource.data.length"
                >
                  <table mat-table [dataSource]="myHomePropertySource" class="mat-elevation-z2 w-100">
                    <ng-container matColumnDef="address">
                      <th mat-header-cell *matHeaderCellDef>Address</th>
                      <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element?.streetAddress && element?.city && element?.state && element?.zip">
                          <div
                            [propertyAddress]="
                              element.streetAddress + ', ' + element.city + ', ' + element.state + ' ' + element.zip
                            "
                          >
                            {{ element.streetAddress }}, {{ element.city }}, {{ element.state }} {{ element.zip }}
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="createdDate">
                      <th mat-header-cell *matHeaderCellDef>Added Date</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element?.createdDate | simpleDate }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="source">
                      <th mat-header-cell *matHeaderCellDef>Source</th>
                      <td mat-cell *matCellDef="let element">
                        {{ constant?.myHomePropertySource[element?.source] }}
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="myHomeColumnList; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: myHomeColumnList"></tr>
                  </table>
                </div>
                <div class="flex_center w-100" *ngIf="!myPropertyLoading && !myPropertyCount">
                  <div class="notFound text-center noData">
                    <div>
                      <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                      <h4>No Properties found</h4>
                    </div>
                  </div>
                </div>
                <mat-paginator #contactGroupPaginator [pageSizeOptions]="[5, 10]" showFirstLastButtons> </mat-paginator>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="mb-3" [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h5 class="my-3 headWrap">Activities</h5>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div>
                <div class="flex_center w-100" *ngIf="isActivityLogLoading">
                  <div class="notFound text-center noData">
                    <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
                    <h4>Please wait while we load</h4>
                  </div>
                </div>
                <div class="table-responsive table_wrap" *ngIf="!isActivityLogLoading">
                  <table mat-table [dataSource]="activityLogDataSource" class="mat-elevation-z2 w-100">
                    <ng-container matColumnDef="category">
                      <th mat-header-cell *matHeaderCellDef>Category</th>
                      <td mat-cell *matCellDef="let element">{{ element.categoryName ? element.categoryName : '' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>Action</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.actionName ? element.actionName : '' }}{{ ' (' + element.count + ')' }}
                      </td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="details">
                        <th mat-header-cell *matHeaderCellDef> Details </th>
                        <td mat-cell *matCellDef="let element">{{element.address ? element.address.street : ''}}
                          {{element.address ? element.address.city : ''}}
                          {{element.address ? element.address.state :''}}
                          {{element.address ? ', ' + element.address.zip : ''}}</td>
                      </ng-container> -->
                    <ng-container matColumnDef="details">
                      <th mat-header-cell *matHeaderCellDef>Details</th>
                      <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.source === 'cmaWidget'; else defaultDetails">
                          {{ constant.SIGN_UP.sourceValue[element.source] }}
                          <span
                            [propertyAddress]="element.source === 'cmaWidget' ? element?.fullAddress : element.address"
                          >
                            ({{ element.fullAddress }})
                          </span>
                        </ng-container>

                        <ng-template #defaultDetails>
                          <span [propertyAddress]="element.details">
                            {{ element.details }}
                          </span>
                        </ng-template>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="lastLogged">
                      <th mat-header-cell *matHeaderCellDef>Last Activity</th>
                      <td mat-cell *matCellDef="let element">{{ element.lastLogDate | simpleDate }}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="actionsColumnList; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: actionsColumnList"></tr>
                  </table>
                </div>
                <div class="flex_center w-100" *ngIf="!isActivityLogLoading && !activityLogCount">
                  <div class="notFound text-center noData">
                    <div>
                      <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                      <h4>No activities found</h4>
                    </div>
                  </div>
                </div>
                <mat-paginator
                  [length]="activityLogCount"
                  [pageSizeOptions]="[5, 10]"
                  (page)="pageChangeOnActivityLogs($event)"
                  showFirstLastButtons
                >
                </mat-paginator>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
